import { Button, Menu, MenuItem, Tab } from "@mui/material";
import { Box } from "@mui/system";
import React, {
  FC,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { PageHeading } from "../../../Components/page-heading.component";
import threedots from "../../../assets/images/threedots.svg";
import { useNavigate } from "react-router-dom";
import { GetAllDto } from "../../../Shared/dto/get-all-dto";
import { PaymentService } from "../../../Services/payment.service";
import { PaymentModel } from "../../../Models/payment.model";
import { DisplayDate, FormatDate } from "../../../Shared/services/date-format";
import { useLoading } from "../../../Shared/services/loading-context";
import { useSnackbar } from "notistack";
import { DisplayAmount } from "../../../Shared/services/amount-format";

interface PaymentReceivedProps { contactId?: number }

const PaymentReceived: FC<any> = forwardRef((props, ref: any) => {
  const navigate = useNavigate();
  const [paymentList, setPaymentList] = useState<PaymentModel[]>([]);
  const [anchorE2, setAnchorE2] = React.useState<null | HTMLElement>(null);
  const [actionToggle, setActionToggle] = useState<any>(false);
  const [rowValue, setRowValue] = useState<any>();
  const [isReceiveModalOpen, setIsReceiveModalOpen] = useState<any>(true);
  const { loading, setLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const redirectReceivable = () => {
    navigate("/payment");
  };

  /**
   * Payment Listing Api
   */
  const getPaymentList = async (searchQuery?: string) => {
    const getAllDto = new GetAllDto("dateAndTime", props.contactId);
    if (searchQuery) {
      getAllDto.searchQuery = searchQuery;
    }
    setLoading(true);
    const response = await PaymentService.getReceivedData(getAllDto);
    setLoading(false);
    if (response.success) {
      setPaymentList(response.data);
    } else enqueueSnackbar(response.message ?? "Internal server error", { variant: "error" });
  };
  console.log(paymentList, "paymentListtttt");

  /**
   * This is used for call parent function in child component
   */
  useImperativeHandle(ref, () => ({
    receivedListingData: getPaymentList,
  }));

  useEffect(() => {
    getPaymentList();
  }, []);

  const editDeleteDropdown = (
    event: React.MouseEvent<HTMLButtonElement>,
    currElemId: any
  ) => {
    setRowValue(currElemId);
    setAnchorE2(event.currentTarget);
    setActionToggle(true);
  };

  const handleCloseEditDelete = () => {
    setActionToggle(false);
  };

  const handleEdit = () => {
    props.editPayment(rowValue);
    setActionToggle(false);
  };

  return (
    <div>
      {paymentList.map((currElem) => {
        return (
          <Box key={currElem.id} className="payment-box">
            <div className="payment-serial-block-no">
              {currElem.receiptNumber ? <><span>#{currElem.receiptNumber}</span> <br /> </> : <></>}
              <span>{currElem.blockNumber}</span>
            </div>

            <div className="payment-textalign">
              <span className="person-name">{currElem.name}</span>
              <br />
              <span className="payment-contactno">
                {currElem.sales?.contact?.mobileNo}
              </span>
            </div>

            <div className="payment-textalign">
              <span className="payment-date">
                {DisplayDate(currElem.dateAndTime)}
              </span>
              <br />
              <span className="payment-due-date">
                {DisplayDate(currElem.dueDate)}
              </span>
            </div>

            <div className="payment-textalign">
              <span className="received-payment-date">
                {DisplayAmount(currElem.paidAmount)}
              </span>{" "}
              <br />
              <span className="received-payment-due-date">
                {currElem.paymentMode}
              </span>
            </div>

            <div className="d-flex">
              <div className="d-grid">
                <span className="amount amount-first">
                  {DisplayAmount(currElem.salesAmount)}
                </span>
                <span className="amount amount-second">
                  {DisplayAmount(currElem.receivedAmount)}
                </span>
              </div>
            </div>
            <div className="website-text-centered col-md-1 col-lg-1">
              <Button
                onClick={(event) => editDeleteDropdown(event, currElem.id)}
              >
                <img src={threedots} />
              </Button>
              <Menu
                anchorEl={anchorE2}
                open={actionToggle}
                onClose={handleCloseEditDelete}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  key={currElem.contactName + "_edit"}
                  onClick={handleEdit}
                >
                  Edit
                </MenuItem>
                <MenuItem>Delete</MenuItem>
              </Menu>
            </div>
          </Box>
        );
      })}
    </div>
  );
});

PaymentReceived.displayName = "PaymentReceived";

export default PaymentReceived;
